import React, { useState } from 'react';
import axios from 'axios';
import AuthPageShell from './shared/AuthPageShell';
import AuthAlert from './shared/AuthAlert';
import './css/Login.css';

const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '/api');

const OrgForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    setIsError(false);
    try {
      const res = await axios.post(`${API_URL}/auth/org-forgot-password`, { email });
      setMessage(res.data.msg || 'If that email has an account, a reset link has been sent.');
    } catch (err) {
      setIsError(true);
      setMessage(err?.response?.data?.msg || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthPageShell title="Reset Organisation Password">
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <input
            type="email"
            className="form-control"
            placeholder="Enter your organisation's email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-warning btn-block mt-3" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Send reset link'}
        </button>
        <AuthAlert message={message} variant={isError ? 'danger' : 'success'} />
      </form>
    </AuthPageShell>
  );
};

export default OrgForgotPassword;
